/* eslint-disable arrow-body-style */
/* eslint-disable no-console */

'use client'

import { useEffect, useRef } from 'react'
import { decodeHTML, cleanJSONLD } from '@components/Product/ProductHead/utils'

const CustomSeoTags = ({ data }) => {
  const productCustomSeoTags = data
  const isTagsAdded = useRef(false)

  useEffect(() => {
    const generateSEOTags = productCustomSeoTags => {
      try {
        if (!productCustomSeoTags) {
          return ''
        }
        const html = decodeHTML(productCustomSeoTags)
        const modifiedHtml = cleanJSONLD(html)

        return modifiedHtml
      } catch (e) {
        console.error(e, 'Seo Tags Error')
      }
    }

    if (!isTagsAdded.current) {
      const generatedHtml = generateSEOTags(productCustomSeoTags)

      if (generatedHtml) {
        const head = document.head || document.getElementsByTagName('head')[0]
        const tempContainer = document.createElement('div')
        tempContainer.innerHTML = generatedHtml
        const fragment = document.createDocumentFragment()

        // Helper function to check for duplicates by `name` or `property`
        const isDuplicateNode = (existingNode, newNode) => {
          const existingName = existingNode.getAttribute('name')
          const existingProperty = existingNode.getAttribute('property')
          const newName = newNode.getAttribute('name')
          const newProperty = newNode.getAttribute('property')

          return (existingName && existingName === newName) || (existingProperty && existingProperty === newProperty)
        }

        // Track nodes to be replaced or added
        const nodesToReplaceOrAdd: any = []

        tempContainer.childNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const clonedNode = node.cloneNode(true)

            // Find and remove existing nodes that match by `name` or `property`
            const existingNode = Array.from(head?.children).find(headNode => isDuplicateNode(headNode, clonedNode))

            if (existingNode) {
              head?.removeChild(existingNode)
            }

            nodesToReplaceOrAdd.push(clonedNode)
          }
        })

        // Add all nodes to the fragment
        nodesToReplaceOrAdd.forEach(node => fragment.appendChild(node))

        // Append the entire fragment to the head
        head?.appendChild(fragment)
      }

      // Mark tags as added
      isTagsAdded.current = true
    }
  }, [productCustomSeoTags])

  return null
}

export default CustomSeoTags
